// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from './axios';

// BudgetFeed import pipeline: upload → review staged rows → commit.
// Backend: IDP/backend/budgetfeed_io/urls.py (mounted at /api/feed/)
export const feedAPI = {
  listFiles: () => api.get('/api/feed/files/'),

  // bankName omitted → backend auto-detects; password only for protected PDFs
  upload: ({ file, bankName, password }, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    if (bankName) formData.append('bank_name', bankName);
    if (password) formData.append('password', password);
    return api.post('/api/feed/upload/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  },

  deleteFile: (fileId) => api.delete(`/api/feed/files/${fileId}/`),

  downloadFile: (fileId) =>
    api.get(`/api/feed/files/${fileId}/download/`, { responseType: 'blob' }),

  listRows: (fileId, status) =>
    api.get(`/api/feed/files/${fileId}/rows/`, {
      params: status ? { status } : {},
    }),

  updateRow: (fileId, rowId, data) =>
    api.patch(`/api/feed/files/${fileId}/rows/${rowId}/`, data),

  // Commits APPROVED rows; if none are approved, all PENDING rows
  commit: (fileId) => api.post(`/api/feed/files/${fileId}/commit/`),

  banks: () => api.get('/api/feed/banks/'),
};

export default feedAPI;
